import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useMeta } from "../lib/seo";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";

export default function About() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [founder, setFounder] = useState("Daniel Will");
  useEffect(() => {
    api.get("/settings/about").then((r) => { if (r.data?.founder_name) setFounder(r.data.founder_name); }).catch(() => {});
  }, []);
  useMeta("About Denial Decoder",
    "Denial Decoder is self-help software that compares your denial letter to your contract and helps you draft your own appeal. Not a law firm.");
  const firstName = founder.trim().split(/\s+/)[0] || founder;
  const initials = founder.trim().split(/\s+/).map((w) => w[0]).join("").slice(0, 2).toUpperCase();
  return (
    <div className="max-w-3xl mx-auto px-4 py-16 sm:py-24 fade-in" data-testid="about-page">
      <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight mb-12">{t("about.h1")}</h1>

      <section data-testid="about-why-section">
        <div className="flex items-center gap-4 mb-6">
          <span className="w-14 h-14 rounded-full bg-emerald-600 text-white text-xl font-extrabold flex items-center justify-center shrink-0" data-testid="founder-monogram">{initials}</span>
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight">{t("about.whyTitle")}</h2>
        </div>
        <div className="text-slate-600 leading-relaxed space-y-4">
          {[1, 2, 3, 4, 5].map((n) => <p key={n} data-testid={`about-why-p${n}`}>{t(`about.whyP${n}`)}</p>)}
          <p data-testid="about-why-bridge">{t("about.whyBridge")}</p>
        </div>
        <p className="mt-6 font-semibold text-slate-800" data-testid="about-signoff">{t("about.signoff", { name: founder })}</p>
      </section>

      <section className="mt-14" data-testid="about-not-law-firm">
        <h2 className="text-2xl sm:text-3xl font-bold tracking-tight">{t("about.legalTitle")}</h2>
        <div className="mt-5 text-slate-600 leading-relaxed space-y-4">
          {[1, 2, 3, 4].map((n) => <p key={n} data-testid={`about-legal-p${n}`}>{t(`about.legalP${n}`)}</p>)}
        </div>
      </section>

      <section className="mt-14" data-testid="about-contact">
        <h2 className="text-2xl sm:text-3xl font-bold tracking-tight">{t("about.contactTitle")}</h2>
        <p className="mt-4 text-slate-600 leading-relaxed" data-testid="about-contact-body">
          {t("about.contactA")}{" "}
          <a href="mailto:support@decodemydenial.com" className="text-emerald-700 font-medium hover:underline" data-testid="about-contact-email">support@decodemydenial.com</a>{" "}
          {t("about.contactB")} {t("about.contactSign", { name: firstName })}
        </p>
      </section>

      <div className="mt-14 text-center">
        <Button size="lg" onClick={() => navigate("/check")} className="bg-emerald-700 hover:bg-emerald-800 rounded-full px-8" data-testid="about-cta">{t("landing.ctaFree")}</Button>
      </div>
    </div>
  );
}
